import { AnalyticsService } from '../../typescript/common/analytics-service';
import './accordion.scss';

(function accordion() {
  // Add tracking
  (document.querySelectorAll('.accordion-button') as NodeListOf<HTMLElement>).forEach((accordionButton) => {
    accordionButton.addEventListener('click', () => {
      AnalyticsService.addEvent(AnalyticsService.Accordion, accordionButton.textContent?.trim() ?? '', document.URL);
    });
  });
})();
